import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "certificates-item p-2" }
const _hoisted_2 = { class: "image mr-2" }
const _hoisted_3 = { class: "certificates-item__content" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "expiredDate" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "next" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-chevron-right mr-3" })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Avatar3 = _resolveComponent("Avatar3")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Avatar3, {
        width: "60px",
        round: true,
        height: "60px",
        avatar: _ctx.certificat?.listImages[0]
      }, null, 8, ["avatar"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.certificat.title), 1),
      _createElementVNode("div", _hoisted_5, " Thời hạn đến: " + _toDisplayString(_ctx.format(new Date(_ctx.certificat.expiredDate), "dd/MM/yyyy")), 1)
    ]),
    _hoisted_6
  ]))
}